<template>
    <FKBreadCrumb :page="$t('page.update_password')">
        <FKBreadCrumbItem :page="$t('page.profile')" to="/profile"/>
    </FKBreadCrumb>
    <UpdatePasswordForm/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from '@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue';
import UpdatePasswordForm from "@/components/FK/Profile/UpdatePasswordForm.vue";

export default defineComponent({
    name: "UpdatePasswordPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        UpdatePasswordForm
    }
})
</script>